// services/persistence.js
const STORAGE_KEYS = {
    random: 'foundly_random_state',
    search: 'foundly_search_state',
    daily: 'foundly_daily_state'
};

// Cache in memoria per accesso veloce (evita parsing JSON ripetuti)
const memoryCache = {
    random: null,
    search: null,
    daily: null,
    cacheTime: {
        random: 0,
        search: 0,
        daily: 0
    }
};

const CACHE_TTL = 1000; // 1 secondo - cache breve per evitare letture multiple durante lo stesso render

const isBrowser = () => typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';

const safeParse = (value) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn('[Persistence] Unable to parse stored value:', error);
        return null;
    }
};

const getKey = (type) => STORAGE_KEYS[type] || null;

const read = (type) => {
    if (!isBrowser()) return null;
    const key = getKey(type);
    if (!key) return null;
    
    // Controlla cache in memoria prima di leggere da sessionStorage
    const now = Date.now();
    if (memoryCache[type] && (now - memoryCache.cacheTime[type]) < CACHE_TTL) {
        return memoryCache[type];
    }
    
    // Leggi da sessionStorage e aggiorna cache
    const data = safeParse(window.sessionStorage.getItem(key));
    memoryCache[type] = data;
    memoryCache.cacheTime[type] = now;
    
    return data;
};

const write = (type, data) => {
    if (!isBrowser()) return;
    const key = getKey(type);
    if (!key) return;
    try {
        const prev = read(type) || {};
        const next = {
            ...prev,
            ...data,
            updatedAt: Date.now()
        };
        
        // Aggiorna cache in memoria
        memoryCache[type] = next;
        memoryCache.cacheTime[type] = Date.now();
        
        // Scrivi su sessionStorage
        window.sessionStorage.setItem(key, JSON.stringify(next));
    } catch (error) {
        console.warn('[Persistence] Unable to write state:', error);
        // Invalida cache in caso di errore
        memoryCache[type] = null;
    }
};

const remove = (type) => {
    if (!isBrowser()) return;
    const key = getKey(type);
    if (!key) return;
    try {
        window.sessionStorage.removeItem(key);
        // Invalida cache
        memoryCache[type] = null;
        memoryCache.cacheTime[type] = 0;
    } catch (error) {
        console.warn('[Persistence] Unable to remove state:', error);
    }
};

export const PersistenceService = {
    getRandomState: () => read('random'),
    setRandomState: (data) => write('random', data),
    clearRandomState: () => remove('random'),

    getSearchState: () => read('search'),
    setSearchState: (data) => write('search', data),
    clearSearchState: () => remove('search'),

    getDailyState: () => read('daily'),
    setDailyState: (data) => write('daily', data),
    clearDailyState: () => remove('daily')
};


